/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  Table,
  Panel,
} from 'react-bootstrap';
import { routerActions } from 'react-router-redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { callAPI } from 'lorautils/api';
import TablePager from 'loracoms/TablePager';
import SearchFlag from 'loracoms/SearchFlag';
import ShowIf from 'loracoms/ShowIf';
import SortBtn from 'loracoms/SortBtn';
import Link from 'loracoms/Link';
import LoadingTable from 'loracoms/LoadingTable';
import IntlMsg from 'lorautils/intl/IntlMsg';
import gatewayActions from 'loraactions/gateway';
import MapOverlay from '../MapOverlay';
import styles from './styles.scss';

const kLimit = 20;
const defaultProps = {
  search: null,
  showSearchFlag: false,
  count: 1,
};

const propTypes = {
  search: React.PropTypes.string,
  intl: React.PropTypes.any.isRequired,
  showSearchFlag: React.PropTypes.bool,
  count: React.PropTypes.number,
  updateGateway: React.PropTypes.func.isRequired,
  updateState: React.PropTypes.object.isRequired,
};

class GatewayList extends React.Component {

  static getQ(search) {
    if (search) {
      const s = search.replace(/[-:]/g, '');
      return `or,name:*${search}*,platform:*${s}*,id:*${s}*,city:*${s}*,area:*${s}*,version:*${s}*,band:*${s}*`;
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      showSearchFlag: props.showSearchFlag,
      updateState: props.updateGateway,
      count: props.count,
      list: [],
      initialStatus: 'pending',
      mark: '',
      more: false,
      sort: '-lastOn',
    };
    this.mark = '';
    this.q = '';
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePrevPage = this.handlePrevPage.bind(this);
    this.handleShowMap = this.handleShowMap.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.loadGatewayList = this.loadGatewayList.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.detailview.gatewaylist');
  }

  componentDidMount() {
    this.mounted = true;
    this.loadGatewayList();
  }

  componentWillReceiveProps(nextProps) {
    const {
      search,
      showSearchFlag,
      count,
      updateState,
    } = nextProps;

    if (search !== this.props.search) {
      this.setState({ reset: Date.parse(new Date()) });
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.q = GatewayList.getQ(search);
      this.mark = '';
      this.searchTimeout = setTimeout(() => {
        this.loadGatewayList();
      }, 500);
    }
    if (showSearchFlag !== this.props.showSearchFlag) {
      this.setState({ showSearchFlag });
    }
    if (count !== this.props.count) {
      this.setState({ count });
    }
    if (updateState !== this.props.updateState) {
      this.setState({ updateState });
      if (updateState.status === 'success') {
        this.loadGatewayList();
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getStatus(gw) {
    const disconnected = (
      <span>
        <i className={`fa fa-circle-o ${styles.disconnected}`} />
        {' '}
        {this.intlMsg.msg('disconnected')}
      </span>
    );
    const connected = (
      <span>
        <i className={`fa fa-circle ${styles.connected}`} />
        {' '}
        {this.intlMsg.msg('connected')}
      </span>
    );

    if (_.isNil(gw.lastOn)) {
      return disconnected;
    }
    if (_.isNil(gw.lastOff)) {
      return connected;
    }
    const onts = moment(gw.lastOn).valueOf();
    const offts = moment(gw.lastOff).valueOf();
    if (onts > offts) {
      return connected;
    }
    return disconnected;
  }

  loadGatewayList() {
    const { sort } = this.state;
    this.setState({ status: 'loading' });

    callAPI({
      endpoint: '/lora/gateways',
      query: {
        q: this.q,
        mark: this.mark,
        sort,
        limit: kLimit,
      },
    }).then((data) => {
      const list = data.list.map(l => ({
        ...l,
        status: this.getStatus(l),
      }));
      if (this.mounted) {
        this.setState({
          initialStatus: 'success',
          status: 'success',
          list,
          more: data.more,
          mark: data.mark,
        });
      }
    }).catch(() => {
      this.setState({
        status: 'failure',
        initialStatus: 'failure',
      });
    });
  }

  handlePrevPage(mark) {
    this.mark = mark;
    this.loadGatewayList();
  }

  handleNextPage(mark) {
    this.mark = mark;
    this.loadGatewayList();
  }

  handleShowMap(gateway) {
    this.setState({
      gateway,
      showMap: true,
    });
  }

  handleSort(sort) {
    this.setState({ sort, mark: '', reset: Math.random() }, () => {
      this.loadGatewayList({ });
    });
  }

  handleSaveLocation(id, point) {
    const { updateGateway } = this.props;
    updateGateway(id, {
      lng: String(point.lng),
      lat: String(point.lat),
    });
  }

  render() {
    const {
      list,
      showSearchFlag,
      showMap = false,
      gateway = {},
      sort,
      initialStatus,
    } = this.state;

    const thead = (
      <thead>
        <tr>
          <th>
            {this.intlMsg.msg('name', 'gateway')}
            <SearchFlag show={showSearchFlag} />
            <SortBtn
              sortName="name"
              handleSort={this.handleSort}
              highLight={sort.indexOf('name') > -1}
            />
          </th>
          <th>
            {this.intlMsg.msg('mac', 'gateway')}
            <SearchFlag show={showSearchFlag} />
            <SortBtn
              sortName="mac"
              handleSort={this.handleSort}
              highLight={sort.indexOf('mac') > -1}
            />
          </th>
          <th> {this.intlMsg.msg('status', 'gateway')} </th>
          <th>
            {this.intlMsg.msg('platform', 'gateway')}
            <SearchFlag show={showSearchFlag} />
            <SortBtn
              sortName="platform"
              handleSort={this.handleSort}
              highLight={sort.indexOf('platform') > -1}
            />
          </th>
          <th>
            {this.intlMsg.msg('area', 'gateway')}
            <SearchFlag show={showSearchFlag} />
          </th>
          <th>
            {this.intlMsg.msg('address', 'gateway')}
            <SearchFlag show={showSearchFlag} />
          </th>
          {/* <th>
            {this.intlMsg.msg('coord', 'gateway')}
          </th> */}
          <th>
            {this.intlMsg.msg('version', 'gateway')}
            <SearchFlag show={showSearchFlag} />
            <SortBtn
              sortName="version"
              handleSort={this.handleSort}
              highLight={sort.indexOf('version') > -1}
            />
          </th>
        </tr>
      </thead>
    );

    if (initialStatus === 'pending') {
      const { count = 1 } = this.state;
      const rows = Math.max(1, Math.min(count, 10));
      return (
        <Panel bsStyle="aisz-white" header={this.intlMsg.msg('header')}>
          <LoadingTable
            cols={8}
            rows={rows}
            className="aisz-table-light"
            striped
            bordered
            responsive
          >
            {thead}
          </LoadingTable>
        </Panel>
      );
    }

    return (
      <Panel bsStyle="aisz-white" header={this.intlMsg.msg('header')}>
        <Table className="aisz-table-light" striped hover bordered responsive>
          {thead}
          <tbody>
            {
              list.map(r => (
                <tr key={r.id}>
                  <td>
                    <Link to={`/gateway/detail/${r.id}`}>{r.name}</Link>
                  </td>
                  <td>
                    <Link to={`/gateway/detail/${r.id}`}>{r.mac}</Link>
                  </td>
                  <td>{r.status}</td>
                  <td>{r.platform}</td>
                  <td>{r.city}</td>
                  <td>{r.area}</td>
                  {/* <td>
                    <ShowIf if={r.lat !== '' && r.lng !== '' && !_.isNil(r.lat) && !_.isNil(r.lng)}>
                      <Link onClick={() => this.handleShowMap(r)}>
                        <i className="fa fa-map-o" />
                      </Link>
                    </ShowIf>
                  </td> */}
                  <td> {r.version} </td>
                </tr>
              ))
            }
          </tbody>
        </Table>
        <ShowIf if={list.length > 0}>
          <div className={`${styles.pager} ${styles.marginT}`}>
            <TablePager
              status={this.state.status}
              mark={this.state.mark}
              more={this.state.more}
              reset={this.state.reset}
              onPrev={m => this.handlePrevPage(m)}
              onNext={m => this.handleNextPage(m)}
            />
          </div>
        </ShowIf>
        <ShowIf if={list.length === 0}>
          <div className={styles.noGateway}>
            <h3>{this.intlMsg.msg('nogateway')}</h3>
            <Link className={styles.buy} onClick={() => window.open('https://shop182693444.taobao.com/category-1275674413.htm')}>
              <i className="fa fa-shopping-cart" />{' '}
              {this.intlMsg.msg('buygateway')}
            </Link>
          </div>
        </ShowIf>
        <MapOverlay
          show={showMap}
          gateways={[gateway]}
          onHide={() => this.setState({ showMap: false })}
          onSave={point => this.handleSaveLocation(gateway.id, point)}
        />
      </Panel>
    );
  }
}

GatewayList.defaultProps = defaultProps;
GatewayList.propTypes = propTypes;

const mapStateToProps = state => ({
  count: state.usage.gateways,
  updateState: state.gateway.updateGateway,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  updateGateway: gatewayActions.updateGateway,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GatewayList));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayList/index.jsx